import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useLocation, useNavigate } from "react-router-dom";
import { StyledButton } from "components/common";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const EditSalaryButton: React.FC = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToEditSalaryView = async () => {
    navigate(UrlHelper.formatPath(`/Employees/Salaries/Edit`), {
      state: { background: location },
    });
  };

  return (
    <StyledButton size="sm" onClick={navigateToEditSalaryView}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.EditSalary)}
    </StyledButton>
  );
};

export default EditSalaryButton;
